import authClient from './authClient';

export const adminLogin = (adminLoginData) => {
    return authClient.post(process.env.REACT_APP_API_URL + '/adminLogin', adminLoginData);
};